import { positions, transitions } from 'react-alert';

/**
 * @see https://github.com/schiehll/react-alert#options
 */
export const alertsConfig = {
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: '30px',
  transition: transitions.SCALE,
};

export const notificationAlertsConfig = {
  position: positions.TOP_RIGHT,
  offset: '5px 10px',
  transition: transitions.SCALE,
};
